export const BADGES_NEW = 'Neuheiten';
export const PRICE_RANGE = 'price-range';
export const BADGES_FACET = 'badgesFacet';
export const DISCOUNT = 'discount';
export const DEAL = 'deal';
export const SPECIAL_OFFER = 'offer3';
export const EXCLUSIVE = 'exclusive';
export const PAYBACK_OFFER = 'Payback-Sonderangebot';
export const PRICETIP = 'priceTip';

export const BADGES_NAMES = {
  PRICETIP,
  DISCOUNT,
  DEAL,
  SPECIAL_OFFER,
  BADGES_NEW,
  EXCLUSIVE,
  PAYBACK_OFFER,
};
